export const colors = {
    "pureBase": "hsla(0, 0%, 100%, 1.000)",
    "pureTop": "hsla(0, 0%, 0%, 1.000)",
    "divider": "hsla(0, 0%, 93.3%, 1.000)",
    "icons": {
        "inverse": "hsla(0, 0%, 100%, 1.000)",
        "mono": "hsla(0, 0%, 25.1%, 1.000)",
        "dimmed": "hsla(0, 0%, 65.1%, 1.000)",
        "subtle": "hsla(0, 0%, 85.1%, 1.000)",
        "primary": "hsla(205, 100%, 65.1%, 1.000)",
        "danger": "hsla(0, 100%, 70%, 1.000)"
    },
    "menu": {
        "active": "hsla(215, 100%, 75.1%, 1.000)",
        "hover": "hsla(200, 77.8%, 77.1%, 1.000)",
        "default": "hsla(200, 77.8%, 77.1%, 0.000)",
        "indicator": "hsla(240, 1.2%, 84.1%, 0.502)",
        "passive": "hsla(215, 100%, 75.1%, 0.149)"
    },
    "feedback": {
        "error": "hsla(0, 78.8%, 70.4%, 1.000)",
        "info": "hsla(205, 77.4%, 63.5%, 1.000)",
        "neutral": "hsla(205, 22.1%, 66.3%, 1.000)",
        "success": "hsla(136, 49.5%, 57.3%, 1.000)",
        "warning": "hsla(30, 91%, 61%, 1.000)"
    },
    "status": {
        "caution": "hsla(57, 57.7%, 62.9%, 1.000)",
        "danger": "hsla(0, 63.5%, 64.5%, 1.000)",
        "folder": "hsla(207, 95.3%, 66.5%, 1.000)",
        "highlight": "hsla(207, 95.3%, 66.5%, 1.000)",
        "good": "hsla(126, 48.1%, 68.2%, 1.000)",
        "neutral": "hsla(0, 0%, 91.8%, 1.000)"
    },
    "transparent": "hsla(0, 0%, 0%, 0.000)",
    "input": {
        "border": {
            "default": "hsla(120, 1.3%, 85.3%, 1.000)"
        }
    }
};